/* eslint-disable global-require */
const axios = require('axios')

// Cria a instância do axios com a URL base
const api = axios.create({
  baseURL: 'https://chat-api.manyconvert.com',
})

/**
 * Busca mensagens do grupo do chat interno
 * @param {string} grupoId - ID do grupo (ex: 'teste', 'suporte', etc)
 * @returns {Promise} Array de mensagens do grupo
 */
async function getMensagensGrupo(grupoId) {
  const res = await api.get(`/api/chat-interno/grupo/${grupoId}`)
  return res.data
}

/**
 * Envia mensagem para o grupo
 * @param {string} grupoId - ID do grupo
 * @param {object} mensagem - Dados da mensagem {text, sender_id, type, url}
 * @returns {Promise} Mensagem enviada
 */
async function enviarMensagemGrupo(grupoId, mensagem) {
  const res = await api.post(`/api/chat-interno/grupo/${grupoId}/mensagem`, mensagem)
  return res.data
}

/**
 * Busca mensagens de conversa direta entre dois atendentes
 * @param {number} atendenteId1 - ID do primeiro atendente
 * @param {number} atendenteId2 - ID do segundo atendente
 * @returns {Promise} Array de mensagens da conversa
 */
async function getMensagensAtendente(atendenteId1, atendenteId2, chatId) {
  const res = await api.get(`/api/chat-interno/individual/${chatId}/${atendenteId1}/${atendenteId2}`)
  return res.data
}

/**
 * Envia mensagem direta para outro atendente
 * @param {number} remetenteId - ID do atendente remetente (senderId)
 * @param {number} destinatarioId - ID do atendente destinatário (receiverId)
 * @param {string} chatId - UUID da conta/e-commerce
 * @param {object} mensagem - Dados da mensagem {senderId, text}
 * @returns {Promise} Mensagem enviada
 */
async function enviarMensagemAtendente(remetenteId, destinatarioId, chatId, mensagem) {
  const res = await api.post(`/api/chat-interno/individual/${chatId}/mensagem/${destinatarioId}`, mensagem)
  return res.data.mensagem
}

/**
 * Envia mídia para o grupo do chat interno
 * @param {string} chatId - UUID da conta/e-commerce
 * @param {File} arquivo - Arquivo de mídia
 * @param {string} texto - Texto opcional que acompanha a mídia
 * @param {number} senderId - ID do atendente remetente
 * @param {Function} onProgress - Callback de progresso do upload
 * @returns {Promise} Resposta com mensagem, mediaUrl e mediaType
 */
async function enviarMidiaGrupo(chatId, arquivo, texto, senderId, onProgress = () => {}) {
  console.log('📡 enviarMidiaGrupo chamada:', {
    chatId,
    arquivo: arquivo.name,
    texto,
    senderId,
    endpoint: `/api/chat-interno/grupo/${chatId}/media`,
  })

  const formData = new FormData()
  formData.append('file', arquivo)
  formData.append('caption', texto || '')
  formData.append('senderId', senderId)

  console.log('📦 FormData preparado:', {
    file: arquivo.name,
    caption: texto || '',
    senderId,
  })

  const res = await api.post(`/api/chat-interno/grupo/${chatId}/media`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: onProgress,
  })

  console.log('✅ Resposta recebida de enviarMidiaGrupo:', res.data)
  return res.data
}

/**
 * Envia mídia para conversa individual do chat interno
 * @param {string} chatId - UUID da conta/e-commerce
 * @param {number} receiverId - ID do atendente destinatário
 * @param {File} arquivo - Arquivo de mídia
 * @param {string} texto - Texto opcional que acompanha a mídia
 * @param {number} senderId - ID do atendente remetente
 * @param {Function} onProgress - Callback de progresso do upload
 * @returns {Promise} Resposta com mensagem, mediaUrl e mediaType
 */
async function enviarMidiaIndividual(chatId, receiverId, arquivo, texto, senderId, onProgress = () => {}) {
  console.log('📡 enviarMidiaIndividual chamada:', {
    chatId,
    receiverId,
    arquivo: arquivo.name,
    texto,
    senderId,
    endpoint: `/api/chat-interno/individual/${chatId}/media/${receiverId}`,
  })

  const formData = new FormData()
  formData.append('file', arquivo)
  formData.append('caption', texto || '') // ✅ Alterado de 'text' para 'caption'
  formData.append('senderId', senderId)

  console.log('📦 FormData preparado:', {
    file: arquivo.name,
    caption: texto || '',
    senderId,
  })

  const res = await api.post(`/api/chat-interno/individual/${chatId}/media/${receiverId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: onProgress,
  })

  console.log('✅ Resposta recebida de enviarMidiaIndividual:', res.data)
  return res.data
}

module.exports = {
  getMensagensGrupo,
  enviarMensagemGrupo,
  getMensagensAtendente,
  enviarMensagemAtendente,
  enviarMidiaGrupo,
  enviarMidiaIndividual,
}
